import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <div className="max-w-2xl mx-auto px-4 md:px-8 py-24 text-center" data-testid="pay-cancel-page">
      <div className="w-16 h-16 rounded-full mx-auto flex items-center justify-center" style={{ background: "rgba(212,175,55,0.16)" }}>
        <XCircle size={32} style={{ color: "var(--mv-gold)" }} />
      </div>
      <h1 className="font-display text-3xl md:text-4xl mv-green-text mt-6">Payment cancelled.</h1>
      <p className="mt-3 text-[15px]" style={{ color: "var(--mv-muted)" }}>
        You cancelled before completing checkout. No money was taken. You can try again anytime.
      </p>
      <div className="mt-8 flex justify-center gap-3">
        <Link to="/pay" className="btn-gold">Try Again</Link>
        <Link to="/" className="btn-ghost">Back Home</Link>
      </div>
    </div>
  );
}
